import { GET_BANNERS, GET_BANNERS_SUCCESS, GET_BANNERS_FAILURE } from "../constants"

const INIT_STATE = {
    banners: false,
    fetching: false,
    error: false
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_BANNERS:
            return { ...state, fetching: true, error: false }

        case GET_BANNERS_SUCCESS:
            return { ...state, fetching: false, error: false, banners: action.payload.banners }

        case GET_BANNERS_FAILURE:
            return { ...state, fetching: false, error: action.payload.err }

        default:
            return { ...state }
    }
}